var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Back_arrow_tail",
    "data-name": "Back arrow tail",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.297,
    height: 32.297,
    viewBox: "0 0 32.297 32.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_4482_-_Outline",
    "data-name": "Ellipse 4482 - Outline",
    d: "M16.148,1.794a14.358,14.358,0,0,0-5.587,27.581A14.358,14.358,0,0,0,21.735,2.922a14.263,14.263,0,0,0-5.587-1.127m0-1.794A16.148,16.148,0,1,1,0,16.148,16.148,16.148,0,0,1,16.148,0Z",
    transform: "translate(0 0)",
    fill: "#9bacb1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "arrow_back_FILL0_wght400_GRAD0_opsz48",
    d: "M17.569,27.139,8,17.569,17.569,8l1.256,1.256-7.416,7.416h15.73v1.794H11.409l7.416,7.416Z",
    transform: "translate(-1.421 -1.421)",
    fill: "#9bacb1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.1576427bc6c193a8f5d3cff24687b16d.svg";
export { ForwardRef as ReactComponent };